import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControl,
    IconButton,
    InputAdornment,
    MenuItem,
    Modal,
    Select,
    TextField
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_CALL_CENTER } from "../../constants/midia";
import { getCallStatusOptions } from "../../services/callCenterService";

const BudgetRequestModalFilter = ({open, onClose, setIsFilter, changeFilter, params}) => {
    
	const [statusOptions, setStatusOptions] = useState([]);
	const [motivoCancelamentoOptions, setMotivoCancelamentoOptions] = useState([]);
	
	const fetchOptions = async () => {
		const options = await getCallStatusOptions(3);
		const cancelamentoOptions = await getCallStatusOptions(5);
		setStatusOptions(options);
		setMotivoCancelamentoOptions(cancelamentoOptions)
	};

    useEffect(() => {
        fetchOptions()
    }, [])

    const midiaOptions = MIDIA_OPTIONS_CALL_CENTER;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{width: '30%', margin: 'auto', overflow: 'scroll'}}
        >
            <Card>
                <CardHeader title={'Filtros'} />
                <Divider />
                <CardContent style={{display: 'flex', flexDirection: 'column'}}>

                    <FormControl sx={{ m: 1, color: '#ffffff' }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                label="Entrada"
                                inputFormat="dd/MM/yyyy"
                                value={params.check_in}
                                onChange={(date) => changeFilter('check_in', date)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <FormControl sx={{ m: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                label="Saída"
                                inputFormat="dd/MM/yyyy"
                                value={params.check_out}
                                onChange={(date) => changeFilter('check_out', date)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Cliente"
                            onChange={(e) => changeFilter("client", e.target.value)}
                            value={params.client}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Operador"
                            onChange={(e) => changeFilter("clerk", e.target.value)}
                            value={params.clerk}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                        />

                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.motivo || 0}
                            onChange={(e) => changeFilter("motivo", e.target.value)}
                        >
                            <MenuItem value={0}>Selecione o motivo do acompanhamento</MenuItem>
                            {statusOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.ds_status}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.motivoCancelamento}
                            onChange={(e) => changeFilter("motivo_cancelamento", e.target.value)}
                        >
                            <MenuItem value={0}>Selecione o motivo do cancelamento</MenuItem>
                            {motivoCancelamentoOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.ds_status}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.midia}
                            onChange={e => changeFilter("midia", e.target.value)}
                            required
                            sx={{
                                fontWeight: !params.midia ? 600 : 500,
                                fontFamily: 'Montserrat',
                            }}
                        >
                            <MenuItem
                                value={0}
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Montserrat',
                                }}
                            >
                                Selecione uma midia
                            </MenuItem>
                            {midiaOptions.map(midia => (
                                <MenuItem
                                    key={midia.id}
                                    value={midia.ds_midia}
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    {midia.ds_midia}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Adultos"
                            onChange={(e) => changeFilter("adults_quantity", e.target.value)}
                            value={params.adults_quantity}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "adults_quantity",
                                                    params.adults_quantity - 1
                                                )
                                            }
                                            edge="start"
                                        >
                                            -
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "adults_quantity",
                                                    params.adults_quantity + 1
                                                )
                                            }
                                            edge="end"
                                        >
                                            +
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Crianças 4-11 anos"
                            onChange={(e) => changeFilter("children_quantity", e.target.value)}
                            value={params.children_quantity}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "children_quantity",
                                                    params.children_quantity - 1
                                                )
                                            }
                                            edge="start"
                                        >
                                            -
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "children_quantity",
                                                    params.children_quantity + 1
                                                )
                                            }
                                            edge="end"
                                        >
                                            +
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Crianças 0-3 anos"
                            onChange={(e) => changeFilter("babies_quantity", e.target.value)}
                            value={params.babies_quantity}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "babies_quantity",
                                                    params.babies_quantity - 1
                                                )
                                            }
                                            edge="start"
                                        >
                                            -
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                changeFilter(
                                                    "babies_quantity",
                                                    params.babies_quantity + 1
                                                )
                                            }
                                            edge="end"
                                        >
                                            +
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Preço maior que"
                            onChange={(e) => changeFilter("price_up", e.target.value)}
                            value={params.price_up}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Preço menor que"
                            onChange={(e) => changeFilter("price_down", e.target.value)}
                            value={params.price_down}
                            inputProps={{
                                sx: { textAlign: "center" },
                            }}
                        />
                    </FormControl>

                    <Button
                        sx={{
                            m: 1,
                            color: "#fff",
                            fontWeight: 700,
                            textTransform: "capitalize",
                        }}
                        onClick={() => {
                            setIsFilter(false)
                        }}
                        color="tertiary"
                        variant="contained"
                    >
                        Filtrar Listagem
                    </Button>
                </CardContent>
            </Card>
        </Modal>
    );
};

export default BudgetRequestModalFilter;
